import { DatePicker, Select, Space } from 'antd'
import moment from 'moment'
import React from 'react'

import { StatisticsLandingPeople } from './statistics-landing-people.component'
import { StatisticsLandingRate } from './statistics-landing-rate.component'
import { StatisticsPostContentTagTrend } from './statistics-post-content-tag-trend.component'
import { StatisticsPostingCount } from './statistics-posting-count.component'
import { StatisticsPostingRate } from './statistics-posting-rate.component'
import { StatisticsFetchType, TimeRange, TimeRangeType } from './statistics.interface'
import s from './statistics.module.less'

export const StatisticsProductUsage = () => {
  const [dateParam, setDateParam] = React.useState<{ [key in TimeRangeType]?: number }>({})
  const [rangeType, setRangeType] = React.useState<TimeRangeType>('year')
  const [value, setValue] = React.useState(moment())

  React.useEffect(() => {
    OnTimeChange(value)
  }, [rangeType])

  function OnTimeChange(value: moment.Moment) {
    switch (rangeType) {
      case 'year': {
        setDateParam({ year: value.year() })
        setValue(value)
        break
      }
      case 'month': {
        setDateParam({ year: value.year(), month: value.month() + 1 })
        setValue(value)
        break
      }
      case 'date': {
        setDateParam({ year: value.year(), month: value.month() + 1, day: value.date() })
        setValue(value)
        break
      }
      // case 'week': {
      //   setDateParam({ year: value.year(), week: value.week() })
      //   setValue(value)
      //   break
      // }
    }
  }

  function PickerWithType({
    type,
    ...props
  }: {
    type: TimeRangeType
    value: moment.Moment
    onChange: (value: moment.Moment | null, dateString: string) => void
  }) {
    if (type === 'date') return <DatePicker {...props} />
    return <DatePicker picker={type} {...props} />
  }

  const range = (
    <Space>
      <Select value={rangeType} onChange={setRangeType}>
        {Object.keys(TimeRange).map((key) => (
          <Select.Option key={key} value={key}>
            {TimeRange[key]}
          </Select.Option>
        ))}
      </Select>
      <PickerWithType value={value} type={rangeType} onChange={(value) => value && OnTimeChange(value)} />
    </Space>
  )

  return (
    <div className={s.productUsage}>
      <div className={s.actions}>{range}</div>
      <div className={s.charts}>
        <StatisticsPostContentTagTrend key={StatisticsFetchType.PostContentTagTypeTrend} range={dateParam} />
        <StatisticsLandingPeople key={StatisticsFetchType.LandingPeopleCount} rangeType={rangeType} range={dateParam} />
        <StatisticsPostingCount key={StatisticsFetchType.PostCount} rangeType={rangeType} range={dateParam} />
        <StatisticsLandingRate key={StatisticsFetchType.LandingRate} range={dateParam} />
        <StatisticsPostingRate key={StatisticsFetchType.PostingRate} range={dateParam} />
      </div>
    </div>
  )
}
